// HelloSign-specific routes removed as part of V3 to V4 migration
// Template building/editing now handled via PandaDoc modal flow in documents-list.vue

export default []
